import React, { useState } from "react";
import "../styles/ClassesSection.css";
import ongrp from "../assets/ongrp.png";
import onper from "../assets/onper.png";
import offgrp from "../assets/offgrp.png";
import offper from "../assets/offper.png";
const ClassesSection = () => {
  const [mode, setMode] = useState("online");

  const classesData = {
    online: [
      {
        title: "Group Sessions",
        image: ongrp,
        description: "Join our energizing group classes via Zoom, perfect for community-driven learning."
      },
      {
        title: "Personal Sessions",
        image: onper,
        description: "One-on-one virtual yoga sessions tailored to your pace and preferences."
      }
    ],
    offline: [
      {
        title: "Group Sessions",
        image: offgrp,
        description: "Train with peers in our calm studio setting — immersive and socially uplifting."
      },
      {
        title: "Personal Sessions",
        image: offper,
        description: "Exclusive in-person sessions for deep guidance and posture correction."
      }
    ]
  };

  return (
    <section className="classes-section" id="classes">
      

      <div className="toggle-wrapper">
        <div className="toggle-container">
          <div
            className={`toggle-indicator ${mode === "offline" ? "toggle-right" : "toggle-left"}`}
          ></div>
          <button onClick={() => setMode("online")} className="toggle-button">
            Online
          </button>
          <button onClick={() => setMode("offline")} className="toggle-button">
            Offline
          </button>
        </div>
      </div>

      <div className="classes-grid">
        {classesData[mode].map((item, index) => (
          <div className="class-card" key={index}>
            <img src={item.image} alt={item.title} className="class-image" />
            <h3 className="class-title">{item.title}</h3>
            <p className="class-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ClassesSection;
